import {
	GET_USER_SOCIAL_REASONS, GET_DELIVERY_ADDRESSES, GET_SOCIAL_REASON_DETAIL, GET_BRANCH_DETAIL, UPDATE_SOCIAL_REASON,
	CREATE_SOCIAL_REASON, DELETE_SOCIAL_REASON, CREATE_BRANCH, UPDATE_BRANCH, ACTIVATE_BRANCH, DEACTIVATE_BRANCH, GET_ERRORS
} from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

const URL_GET_SOCIAL_REASON_DETAIL = process.env.REACT_APP_API_URL + services.getSocialReasonDetail;
const URL_GET_USER_SOCIAL_REASONS  = process.env.REACT_APP_API_URL + services.getUserSocialReasons;
const URL_UPDATE_SOCIAL_REASON     = process.env.REACT_APP_API_URL + services.updateSocialReason;
const URL_CREATE_SOCIAL_REASON     = process.env.REACT_APP_API_URL + services.createSocialReason;
const URL_DELETE_SOCIAL_REASON     = process.env.REACT_APP_API_URL + services.deleteSocialReason;
const URL_DELIVERY_ADDRESSES       = process.env.REACT_APP_API_URL + services.getDeliveryAddresses;
const URL_GET_BRANCH_DETAIL        = process.env.REACT_APP_API_URL + services.getBranchDetail;
const URL_DEACTIVATE_BRANCH        = process.env.REACT_APP_API_URL + services.deactivateBranch;
const URL_ACTIVATE_BRANCH          = process.env.REACT_APP_API_URL + services.activateBranch;
const URL_CREATE_BRANCH            = process.env.REACT_APP_API_URL + services.createBranch;
const URL_UPDATE_BRANCH            = process.env.REACT_APP_API_URL + services.updateBranch;

export const getSocialReasons = (idUser) => dispatch => {
    const URL = URL_GET_USER_SOCIAL_REASONS + idUser;
	axios.get(URL).then(res => {
        dispatch({
            type:    GET_USER_SOCIAL_REASONS,
            payload: res.data.result
        })
	}).catch(error => {
        dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(error)
        })
    });
};

export const getDeliveryAddresses = (socialReasonId, isActive) => dispatch => {
    const URL = URL_DELIVERY_ADDRESSES + '?razonSocialId=' + socialReasonId + '&is_active=' + isActive;
	axios.get(URL).then(res => {
			dispatch({
				type:    GET_DELIVERY_ADDRESSES,
				payload: res.data.result
			})
	}).catch(error => {
        dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(error)
        })
    });
};

export const getSocialReasonById = (id) => dispatch => {
	const URL = URL_GET_SOCIAL_REASON_DETAIL + id;
	axios.get(URL).then(res => {
        dispatch({
            type:    GET_SOCIAL_REASON_DETAIL,
            payload: res.data.result
        })
    })
    .catch(err => {
        dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(err)
        })
    });
};

export const getBranchById = (id) => dispatch => {
	const data = {
		sucursalId: id
	};

	axios.post(URL_GET_BRANCH_DETAIL, data).then(res => {
        dispatch({
            type:    GET_BRANCH_DETAIL,
            payload: res.data.result
        })
    })
    .catch(err => {
        dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(err)
        })
    });
};

export const updateSocialReason = (data) => dispatch => {
	axios.patch(URL_UPDATE_SOCIAL_REASON, data)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type:    UPDATE_SOCIAL_REASON,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type:    GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const createSocialReason = (email, innerBranchId, usuarioMb, usuarioSAP) => dispatch => {
	var data = {
		email,
		innerBranchId,
		usuarioMb,
		usuarioSAP
	};
	axios.post(URL_CREATE_SOCIAL_REASON, data).then(res => {
		dispatch({
			type:    CREATE_SOCIAL_REASON,
			payload: res.data
		})
	}).catch(error => {
		dispatch({
			type:    GET_ERRORS,
			payload: getErrorMessage(error)
		});
	});
}

export const deleteSocialReason = (_id) => dispatch => {
	axios.delete(URL_DELETE_SOCIAL_REASON + _id).then(res => {
		dispatch({
			type:    DELETE_SOCIAL_REASON,
			payload: res.result
		});
	}).catch(error => {
		dispatch({
			type:    GET_ERRORS,
			payload: getErrorMessage(error)
		})
	});
};

export const createBranch = (data) => dispatch => {
	axios.post(URL_CREATE_BRANCH, data).then(res => {
		if (res.data.status.code === '0000')
			dispatch({
				type:    CREATE_BRANCH,
				payload: {
					message: res.data
				}
			})
	}).catch(error => {
		dispatch({
			type:    GET_ERRORS,
			payload: getErrorMessage(error)
		})
	});
}

export const updateBranch = (data) => dispatch => {
	axios.patch(URL_UPDATE_BRANCH, data).then(res => {
		if (res.data.status.code === '0000')
			dispatch({
				type:    UPDATE_BRANCH,
				payload: {
					message: res.data
				}
			})
	}).catch(error => {
		dispatch({
			type:    GET_ERRORS,
			payload: getErrorMessage(error)
		})
	});
}

export const deactivateBranch = (id) => dispatch => {
	let url = URL_DEACTIVATE_BRANCH + id;
	axios.delete(url).then(res => {
			if (res.data.status.code === "0000")
				dispatch({
					type:    DEACTIVATE_BRANCH,
					payload: {
						message: res.data
					}
				})
		}).catch(error => {
			dispatch({
				type:    GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const activateBranch = (id) => dispatch => {
	const data = {
		id
	};
	axios.patch(URL_ACTIVATE_BRANCH, data).then(res => {
		if (res.data.status.code === "0000")
			dispatch({
				type:    ACTIVATE_BRANCH,
				payload: {
					message: res.data
				}
			})
	}).catch(error => {
		dispatch({
			type:    GET_ERRORS,
			payload: getErrorMessage(error)
		})
	});
}